/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  display_order: z.number(),
  is_active: z.boolean(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const MaterialDivisionBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type MaterialDivisionBase = z.infer<typeof base>;
export type MaterialDivisionBasePutPayload = z.infer<typeof put>;
export type MaterialDivisionBasePatchPayload = z.infer<typeof patch>;
export type MaterialDivisionBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type MaterialDivisionBaseCreateAttributes = z.infer<typeof create>;
export type MaterialDivisionBaseUpdateAttributes = z.infer<typeof update>;
export type MaterialDivisionBaseCacheAttributes = z.infer<typeof cache>;
export type MaterialDivisionBaseCachesAttributes = z.infer<typeof caches>;